import { actions, types } from './requests'
export const DELETEWORKORDER_TYPES = {
    ...types('DELETEWORKORDER'),
}
export const DELETEWORKORDER_ACTIONS = {
    ...actions('DELETEWORKORDER'),
}